import React, {useState, useEffect, useRef} from "react";
import {DEFAULT_BLUE} from "../../../constants/general-constants";
import {functions} from "../../../constants/common-functions";
import {STRINGIFY} from "../../../constants/general-constants";
import {INPUT_TYPE_TEXT} from "../../../constants/input-types";
import EditChildPanel from '../components/EditChildPanel';

export default function AdminListPanelClassificationItems({id}){
	
	const [classificationItems, setClassificationItems] = useState([]);
	const [childId, setChildId] = useState("-100");
	const [childName, setChildName] = useState("-100");
	const [childEditDisplay, setChildEditDisplay] = useState("none");
	
	const refChildCode = useRef(null);
	const refChildName = useRef(null);
	
	useEffect(() => {
		
		loadChildren();
	}, [id]);
	
	const loadChildren = () => {
		functions.getArrayFromAjax("/resolution/classificationitemsforclassification?classificationId=" + id,  null, populateClassificationItems);
	};
	
	const childComponentRows = [
		{ref:refChildCode, id:"1", title:"Code", inputType:INPUT_TYPE_TEXT},
		{ref:refChildName, id:"2", title:"Name", inputType:INPUT_TYPE_TEXT},
	];
	
	const populateClassificationItems = (results) => {
		let tempClassificationItems = [];
		for(let i=0; i<results.length; i++){
			tempClassificationItems.push({
				id:results[i].id,
				name:results[i].name
			});
		}
		setClassificationItems(tempClassificationItems);
	};
	
	const thisContainer = {
		display:"flex",
		width:"calc(50% - 40px)",
		backgroundColor:"#eee",
		borderRadius:"4px",
		minHeight:"200px",
		marginLeft:"30px",
		flexDirection:"column",
		paddingBottom:"30px"
	};
	
	const titlePanel = {
		display:'flex',
		width:"calc(100% - 20px)",
		alignItems:"center",
		justifyContent:"space-between",
		color:"black",
		height:"40px",
		fontSize:"14px",
		marginLeft:"10px"
	};
	
	const blueButton = {
		display:"flex",
		width:"100px",
		height:"20px",
		backgroundColor:DEFAULT_BLUE,
		borderRadius:"15px",
		color:"white",
		fontSize:"12px",
		cursor:"pointer",
		marginRight:"10px",
		marginTop:"0px",
		alignItems:"center",
		justifyContent:"space-around",
		boxShadow:'0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.13)',
	};
	
	const rowContainer = {
		display:"flex",
		width:"calc(100% - 40px)",
		marginLeft:"20px",
		flexDirection:"column",
		marginTop:"10px"
	}
	
	const itemRow = {
		display:"flex",
		height:"40px",
		marginBottom:"1px",
		backgroundColor:"white",
		alignItems:'center',
		paddingLeft:"10px",
		justifyContent:"space-between",
		fontSize:"12px",
	};
	
	const goEdit = (editId, editName) => {
		setChildId(editId);
		setChildName(editName);
		functions.getObjectFromAjax("/resolution/classificationitem?id=" + editId,  null, populateChild);
		setChildEditDisplay("flex");
	};
	
	const populateChild = (child) => {
		if(child){
			refChildCode.current.value = child.code;
			refChildName.current.value = child.name;
		}
	};
	
	const rowDisplay = classificationItems.map((item, index) => 
		<div style={itemRow}>
			{item.name}
			<div style={blueButton} onClick={() => {goEdit(item.id, item.name)}}>
				Edit
			</div>
		</div>
	);
	
	const childEditDisplayPanel = {
		display:childEditDisplay,
		position:"absolute",
		right:"30px",
		top:"100px",
		width:"600px",
		backgroundColor:"white",
		boxShadow:'0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.13)'
	};
	
	const getChildTitle = () => {
		return "Child Details: " + childName
	};
	
	const resetBoxDisplay = () => {
		setChildEditDisplay("none");
		setChildName("New");
		setChildId("-100");
		refChildCode.current.value = "";
		refChildName.current.value = "";
	};
	
	const clickChildCancel = () => {
		resetBoxDisplay();
	}; 
	
	const clickChildSave = () => {
		goSubmit();
	};
	
	const clickChildDelete = () => {
		goDelete();
	};
	
	const getSubmitObject = () => {
		let submitObject = {
			id:childId,
			code:refChildCode.current.value,
			name:refChildName.current.value,
			classificationId:id,
			parentId:"0",
			includeInReport:"true",
			isMeeting:"false"
		};
		return submitObject
	}
	
	const goSubmit = () => {
		
		functions.submitAjax("/resolution/classificationitemsave", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
		
	};
	
	const handleSubmitError = (e) => {
		console.log(e);
	};
	
	const saveEnd = () => {
		loadChildren();
		resetBoxDisplay();
	};
	
	const goDelete = () => {
		functions.submitAjax("/resolution/classificationitemdelete", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
	};
	
	return (
		<div style={thisContainer}>
			<div style={titlePanel}>
				Classification Options (Items)
				<div style={blueButton} onClick={() => {goEdit('-100', 'New');}}>
					Add
				</div>
			</div>
			<div style={rowContainer}>
				{rowDisplay}
			</div>
			
			<div style={childEditDisplayPanel}>
				<EditChildPanel
					title={getChildTitle()}
						componentRows = {childComponentRows}
						clickChildCancel={clickChildCancel} 
						clickChildSave={clickChildSave}
						clickChildDelete={clickChildDelete}
				/>
			</div>
			
		</div>
		
	);
}